import React from 'react';
import { usePage } from '@inertiajs/react';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/ui/button';
import AuthPanel from '../../components/layout/auth/AuthPanel';

export default function ProviderLogin({ federationProvider, pageTranslations }) {
    const { flash } = usePage().props;

    return (
        <AuthPanel>
            {flash && <Alert variant={flash.type}>{flash.description}</Alert>}

            <div className="text-center space-y-4">
                <p className="text-sm text-[#003545]">
                    {pageTranslations.welcomeIntro}<br />
                    {pageTranslations.intro}
                </p>

                {federationProvider && federationProvider.enabled ? (
                    <Button variant="primary" asChild className="w-full">
                        <a href={`/auth/${federationProvider.slug}`}>
                            {pageTranslations.loginButton}
                        </a>
                    </Button>
                ) : (
                    <>
                        <Button variant="primary" disabled className="w-full">
                            {pageTranslations.loginButton}
                        </Button>
                        <p className="text-sm text-red-600">
                            {pageTranslations.loginNotPossible}
                        </p>
                    </>
                )}
            </div>
        </AuthPanel>
    );
}
